import React, { Component } from 'react';
import PropTypes from 'prop-types';
import locales from '../locales';

const ICON_CARET_DOWN = 'ri-arrow-down-s-line';
const ICON_COMPANY = 'ri-store-line';

class CompanySelector extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(e) {
    if (this.containerRef.current && !this.containerRef.current.contains(e.target)) {
      this.setState({ isOpen: false });
    }
  }

  handleToggle() {
    this.setState(prev => ({ isOpen: !prev.isOpen }));
  }

  handleSelect(id) {
    const { onChangeCompany } = this.props;
    this.setState({ isOpen: false });

    if (onChangeCompany) {
      onChangeCompany(id);
    } else {
      document.location = `/?company_id=${id}`;
    }
  }

  getCurrentCompany() {
    const { companies, currentCompanyId } = this.props;
    return companies.find(c => c.id === currentCompanyId) || companies[0];
  }

  render() {
    const { companies, lang } = this.props;
    if (!companies || companies.length === 0) return null;

    const currentCompany = this.getCurrentCompany();
    if (!currentCompany) return null;

    const { isOpen } = this.state;
    const t = locales(lang);

    return (
      <div className="sidebar__companies" ref={this.containerRef}>
        <label className="label__companies">{t('globalSidebar.companies.label')}</label>
        <div className="sidebar__company-dropdown">
          <button
            type="button"
            className={`sidebar__company-trigger ${isOpen ? 'is-active' : ''}`}
            onClick={this.handleToggle}
          >
            <span>{currentCompany.name}</span>
            <i
              className={`${ICON_CARET_DOWN} sidebar__company-trigger-icon ${
                isOpen ? 'is-open' : ''
              }`}
            />
          </button>
          {isOpen && (
            <div className="sidebar__company-menu">
              {companies.map(company => {
                const isActive = company.id === currentCompany.id;
                return (
                  <button
                    key={company.id}
                    type="button"
                    className={`sidebar__company-item ${isActive ? 'is-active' : ''}`}
                    onClick={() => this.handleSelect(company.id)}
                  >
                    <i className={`${ICON_COMPANY} sidebar__company-item-icon`} />
                    <span>{company.name}</span>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }
}

CompanySelector.propTypes = {
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  currentCompanyId: PropTypes.string,
  onChangeCompany: PropTypes.func,
  lang: PropTypes.string.isRequired,
};

export default CompanySelector;
